import color from '@theme/Colors';
import React, { SVGProps } from 'react';

type Props = {
    isSecondaryVerificationQueue?: boolean;
} & SVGProps<SVGSVGElement>;

function VerificationIcon(props: Props) {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            className="icon-svg-stroke"
            width={props.isSecondaryVerificationQueue ? '24' : '24'}
            height={props.isSecondaryVerificationQueue ? '24' : '24'}
            fill="none"
            viewBox={'0 0 24 24'}
            stroke={color.grey600}
        >
            {props.isSecondaryVerificationQueue ? (
                <g transform="scale(1.15) translate(-1.56, -1.56)">
                    <path
                        d="M12 21C12 21 19.25 17.4 19.25 12V5.7L12 3L4.75 5.7V12C4.75 17.4 12 21 12 21Z"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 11.5C12.5523 11.5 13 11.0523 13 10.5C13 9.94772 12.5523 9.5 12 9.5C11.4477 9.5 11 9.94772 11 10.5C11 11.0523 11.4477 11.5 12 11.5Z"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M12 11.5V14"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            ) : (
                <path
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M15 10l-2.021 2.509C12.178 13.503 11.777 14 11.25 14c-.527 0-.927-.497-1.728-1.491L9 11.862M18.89 16c1.6-2.92 2.012-6.25 2.093-8.363.046-1.21-.953-2.137-2.165-2.137h-.589a1.75 1.75 0 01-1.75-1.75A1.75 1.75 0 0014.729 2H9.563a2.042 2.042 0 00-2.042 2.042A2.042 2.042 0 015.48 6.083h-.31c-1.207 0-2.206.92-2.145 2.126.099 1.95.532 4.96 2.086 7.791.423.77.997 1.543 1.634 2.28 1.98 2.287 2.97 3.43 5.255 3.43 2.285 0 3.275-1.143 5.255-3.43.637-.737 1.212-1.51 1.634-2.28z"
                ></path>
            )}
        </svg>
    );
}

export default VerificationIcon;
